import { render, staticRenderFns } from "./LoadSavedSearch.vue?vue&type=template&id=5abb8b30&scoped=true&"
import script from "./LoadSavedSearch.vue?vue&type=script&lang=js&"
export * from "./LoadSavedSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb8b30",
  null
  
)

export default component.exports